import { useEffect } from 'react'

import { usePostHog } from 'posthog-js/react'
import { posthogManager } from 'utils/posthog/manager'
import { initPerformanceObservers } from 'utils/posthog/performance'

// Module-level guard prevents double-initialization even if the singleton import
// is duplicated (e.g. different module instances in HMR or SSR edge cases)
let managerInitialized = false

export function PosthogManagerProvider({
  children
}: {
  children: React.ReactNode
}) {
  const posthog = usePostHog()
  useEffect(() => {
    if (!posthog || managerInitialized || posthogManager.isInitialized()) return

    posthogManager.initialize(posthog)
    managerInitialized = true
    initPerformanceObservers()
  }, [posthog])

  return <>{children}</>
}
